export const messages = {
  en: {
    reserveConfirm: {
      scanPlaceholder: 'Please scan the QR code',
      confirm: 'Confirm',
      result: 'Result',
      confirmTime: 'Confirm Time',
      goodsService: 'Goods/Service',
      quantity: 'Quantity',
      appointmentDate: 'Appointment Date',
      appointmentHour: 'Appointment Hour',
      appointmentPerson: 'Appointment Person',
      appointmentPhone: 'Appointment Phone',
      remark: 'Remark',
      searchCondition: 'Search Condition',
      personNamePlaceholder: 'Please enter person name',
      personTelPlaceholder: 'Please enter phone number',
      appointmentTimePlaceholder: 'Please select appointment time',
      search: 'Search',
      orderId: 'Order ID',
      scanWarning: 'Please scan the QR code',
      confirmSuccess: 'Confirm success',
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    reserveConfirm: {
      scanPlaceholder: '请扫码枪扫码核销',
      confirm: '核销',
      result: '核销结果',
      confirmTime: '核销时间',
      goodsService: '商品/服务',
      quantity: '核销数量',
      appointmentDate: '预约日期',
      appointmentHour: '预约小时',
      appointmentPerson: '预约人',
      appointmentPhone: '预约电话',
      remark: '备注',
      searchCondition: '查询条件',
      personNamePlaceholder: '请输入预约人',
      personTelPlaceholder: '请输入预约电话',
      appointmentTimePlaceholder: '请选择预约时间',
      search: '查询',
      orderId: '核销订单',
      scanWarning: '请扫码',
      confirmSuccess: '核销成功',
      fetchError: '获取数据失败'
    }
  }
}